@if (appContext.isSystemlink) {
  <router-outlet></router-outlet>
} @else {
  @if (!env.maintenance) {
    <div id='screen' [ngClass]="{'container-fluid px-0': !appContext.isNewRoute, 'new-look-and-feel': appContext.useNewLookAndFeel() }">
      <!--spinning wheel-->
      <div [hidden]="appContext.pendingProcesses.length === 0" class="position-fixed row h-100 w-100 m-0"
        style="z-index: 15000;">
        <div class="position-absolute bg-secondary h-100 w-100" style="opacity: 0.3"></div>
        @if (appContext.isNewRoute) {
          <img class=" mx-auto text-secondary align-self-center" src="assets/img/loading-icon.svg"
            style="width: 6rem; height: 6rem;"/>
        } @else {
          <div class="spinner-border mx-auto text-secondary align-self-center" role="status"
          style="width: 5rem; height: 5rem; border-width: 1rem;"></div>
        }
      </div>
      @if (appContext.userProfile) {
<div [ngClass]="{'admin' : appContext.isAdmin(), 'd-flex flex-column': appContext.isNewRoute,
    'min-vh-100': appContext.isNewRoute && !appContext.routeData?.manualScrolling,
    'vh-100': appContext.isNewRoute && appContext.routeData?.manualScrolling}">
          <!-- STI-down banner: read-only system-health status, non-dismissible by design
               (reflects an ongoing problem, not a one-time notice). Placed above both sticky
               navbars so it doesn't disturb their `top: 3.5rem` / z-index offset math. -->
          @if (appContext.stiDownStatus?.isDown) {
            <app-status-alert type="danger" [closeable]="false" cssClass="mb-0">
              <div class="row">
                <div class="col-12">
                  <h6>ICS2 – Shared Trading Interface</h6>
                </div>
                @for (downType of appContext.stiDownStatus.downTypes; track downType) {
                  <div class="col-12">{{ downType.description }}</div>
                }
              </div>
            </app-status-alert>
          }
          <!-- Top navbar -->
          <div class="row bg-portbase-blue sticky-top mx-0" style="z-index: 1029;">
            <nav class="page-section col navbar navbar-dark">
              <div class="container-fluid">
                <div class="w-100 d-sm-none navigation-mobile d-flex justify-content-between px-3">
                  <!-- Portbase logo -->
                  <a class="navbar-brand d-flex align-items-center" [attr.href]="s000Url" tabindex="-1">
                    <img src="assets/pb-logo.svg" class="d-inline-block align-top" alt="Portbase logo" width="128" height="32"/>
                    <span class="d-none d-sm-inline ms-3 ps-3 border-start">Port Visit</span>
                  </a>
                  <!-- mobile navbar buttons -->
                  <div class="d-flex justify-content-end">
                    <!-- top menu dropdown -->
                    <div class="btn-group">
                      <button class="btn btn-primary rounded bg-portbase-blue border-white" type="button" data-bs-toggle="dropdown">
                        <span class="fa-light fa-bars"></span>
                      </button>
                      <div class="dropdown-menu dropdown-menu-end mobile-menu">
                        @if (appContext.isAllowedToViewVisits()) {
                          <a [routerLink]="['/']" class="dropdown-item">Visits</a>
                        }
                        @if (appContext.isVisitDeclarant()) {
                          <a [routerLink]="['/newVisit']" class="dropdown-item">
                          New visit</a>
                        }
                        @if (appContext.isBunkerOperator() || appContext.isAdmin()) {
                          <a [routerLink]="['/bunkering']"
                          class="dropdown-item">Bunkering</a>
                        }
                        <a class="dropdown-item has-news beamer-button" data-bs-toggle="tab" role="tab" tabindex="-1">News</a>
                        @if (appContext.isServiceDesk()) {
                          <a href="#" class="dropdown-item" data-bs-toggle="modal" data-bs-target="#logOutModal" tabindex="-1">
                            Log out as Service Desk
                          </a>
                        }
                        @if (!isEmergencyProcedureDisabled &&
                            (appContext.isAdmin() || appContext.isServiceDesk())) {
                          <div class="dropdown-divider"></div>
                            <a class="dropdown-item"
                              data-bs-toggle="modal"
                              data-bs-target="#emergencyProcedureSettings">
                              Emergency procedure
                            </a>
                          <div class="dropdown-divider"></div>
                        }
                        <a class="dropdown-item" [attr.href]="s000Url">Go to home screen</a>
                        <a class="dropdown-item" [attr.href]="iamLogoutUrl">Leave Portbase PCS</a>
                        @if (!visitContext.isOrganisationOnlyCargoDeclarant()
                          && !appContext.isCustoms() && !visitContext.isAssignedFinancialDeclarant()) {
                          <div class="border-top border-dark col mt-2">
                            <app-confirmation-of-purchase></app-confirmation-of-purchase>
                            <app-notification-of-departure></app-notification-of-departure>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-none d-sm-flex justify-content-between w-100">
                  <!-- Portbase logo -->
                  <a class="navbar-brand d-flex align-items-center" [attr.href]="s000Url" tabindex="-1">
                    <img src="assets/pb-logo.svg" class="d-inline-block align-top" alt="Portbase logo" width="128" height="32"/>
                    <span class="d-none d-sm-inline ms-3 ps-3 border-start">Port Visit</span>
                  </a>
                  <!-- User profile dropdown (not displayed on mobile) -->
                  <div class="btn-group d-none d-sm-block">
                    <button class="btn text-white dropdown-toggle" type="button" data-bs-toggle="dropdown" tabindex="-1" id="user-button">
                      {{appContext.userProfile.organisation?.contact}}
                    </button>
                    <div class="dropdown-menu dropdown-menu-end">
                      <a [routerLink]="['/preferences']" class="dropdown-item" href="#">Preferences</a>
                      @if (appContext.isAdmin() || appContext.isCargoImportEditor()) {
                        <a [routerLink]="['/licensebook']"
                        class="dropdown-item">Warehouse licences</a>
                      }
                      @if (!cargoScreenEnabled) {
                        <a [routerLink]="['/addressbook']" class="dropdown-item">Address book</a>
                      }
                      @if (appContext.isTransitViewer()) {
                        <a [routerLink]="['/guarantees']" class="dropdown-item">
                        Transit guarantees</a>
                      }
                      @if (appContext.isTransitViewer()) {
                        <a [routerLink]="['/transitTemplates']" class="dropdown-item">
                        Transit templates</a>
                      }
                      @if (appContext.isTransitViewer()) {
                        <a [routerLink]="['/transitAddressBook']" class="dropdown-item">
                        Transit destinations</a>
                      }
                      @if (appContext.isCommercialReleaseDeclarant() || appContext.isCommercialReleaseEditor() ||
                        appContext.isCommercialReleaseViewer()) {
                        <a [routerLink]="['/releaseToParties']" class="dropdown-item">
                        Release-to parties</a>
                      }
                      <div class="dropdown-divider"></div>
                      @if (appContext.isAdmin()) {
                        <a [routerLink]="['/admin/panel']" class="dropdown-item">Admin panel</a>
                        <a [routerLink]="['/admin/organisationSettings']" class="dropdown-item">Organisation settings</a>
                        <a [routerLink]="['/admin/monitoring']" class="dropdown-item">Monitoring</a>
                        <a [routerLink]="['/commercial-release-dashboard']" class="dropdown-item">
                        Commercial release dashboard</a>
                        <a [routerLink]="['/encrypt']" class="dropdown-item">Encrypt</a>
                        <div class="dropdown-divider"></div>
                      }
                      @if (appContext.isServiceDesk()) {
                        <a href="#" class="dropdown-item" data-bs-toggle="modal" data-bs-target="#logOutModal">Log out as Service Desk</a>
                      }
                        @if (!isEmergencyProcedureDisabled &&
                            (appContext.isAdmin() || appContext.isServiceDesk())) {
                        <div class="dropdown-divider"></div>
                          <a class="dropdown-item"
                            data-bs-toggle="modal"
                            data-bs-target="#emergencyProcedureSettings">
                            Emergency procedure
                          </a>
                        <div class="dropdown-divider"></div>
                      }
                      <a class="dropdown-item" [attr.href]="s000Url">Go to home screen</a>
                      <a class="dropdown-item" [attr.href]="iamLogoutUrl">Leave Portbase PCS</a>
                      @if (appContext.environment === 'localhost') {
                        <div class="dropdown-divider"></div>
                      }
                      @if (appContext.environment === 'localhost') {
                        <div class="dropdown-item">
                          <app-user-menu></app-user-menu>
                        </div>
                      }
                      @if (appContext.isAdmin()) {
                        <div class="dropdown-item">
                          <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" role="switch" id="useNewLookAndFeelSwitch"
                                   [(ngModel)]="useOpenSearch" (ngModelChange)="changeUseOpenSearch($event)">
                            <label class="form-check-label pt-1" for="useNewLookAndFeelSwitch">Use OpenSearch</label>
                          </div>
                        </div>
                      }
                      @if (appContext.isAdmin()) {
                        <div class="dropdown-divider"></div>
                      }
                      @if (visit && !visitContext.isOrganisationOnlyCargoDeclarant() && !appContext.isCustoms() && !visitContext.isAssignedFinancialDeclarant()) {
                        <div class="border-top border-dark col mt-2 d-sm-none" style="min-width:20rem;">
                          <app-confirmation-of-purchase></app-confirmation-of-purchase>
                          <app-notification-of-departure></app-notification-of-departure>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </nav>
          </div>
          <!-- Sub-navbar mobile (XS screen size) -->
          @if (!appContext.isNewRoute) {
            <nav class="navbar navbar-light bg-white d-block d-sm-none sticky-top pb-2 ps-0 mx-0" style="top: 3.5rem; z-index: 1028;">
              <div class="container-fluid px-0">
                <a class="navbar-brand" href="#">
                  <app-vessel-details></app-vessel-details>
                </a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText"
                  aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                  <i class="fa fa-caret-down" aria-hidden="true"></i>
                </button>
                <div class="collapse navbar-collapse" id="navbarText">
                  <app-visit-status [mobile]="true"></app-visit-status>
                </div>
              </div>
            </nav>
          }
          <!-- Sub-navbar desktop -->
          <div class="row bg-portbase-blue sticky-top mx-0" style="top: 3.5rem; z-index: 1028;">
            <nav class="page-section col vesselcall-nav">
              <div class="nav nav-tabs navbar-dark border-bottom-0" role="tablist">
                <!-- Everything from this point is not rendered on small screens -->
                @if (appContext.isAllowedToViewVisits()) {
                  <a [routerLink]="['/']"
                    [ngClass]="{'active': appContext.getUrlPath() === '/'}" id="visit_overview-link" data-bs-toggle="tab"
                  role="tab" class="nav-item nav-link d-none d-sm-block" tabindex="-1">Visits</a>
                }
                @if (!isEmergencyProcedureDisabled && appContext.hasEmergencyProcedureAccess()) {
                  <a [routerLink]="['/emergency']"
                     [ngClass]="{'active': appContext.getUrlPath() === '/emergency'}"
                     class="nav-item nav-link d-none d-sm-block" id="emergency-procedure-link" data-bs-toggle="tab"
                     role="tab" tabindex="-1">Emergency</a>
                }
                @if (appContext.isAdmin() || appContext.isHarbourDuesViewer()) {
                  <a [routerLink]="['/port-dues']"
                     [ngClass]="{'active': appContext.getUrlPath() === '/port-dues'}"
                     class="nav-item nav-link d-none d-sm-block" id="port_dues-overview-link" data-bs-toggle="tab" role="tab"
                     tabindex="-1">Port Dues</a>
                }
                @if (appContext.isVisitDeclarant() && !appContext.useNewLookAndFeel()) {
                  <a [routerLink]="['/newVisit']"
                    [ngClass]="{'active': appContext.getUrlPath() === '/newVisit'}"
                    class="nav-item nav-link d-none d-sm-block" id="new_visit-link" data-bs-toggle="tab" role="tab"
                  tabindex="-1">New visit</a>
                }
                @if (cargoScreenEnabled) {
                  <a [routerLink]="['/cargo']"
                    [ngClass]="{'active': appContext.getUrlPath() === '/cargo' || appContext.getUrlPath() === '/container'}"
                    class="nav-item nav-link d-none d-sm-block" id="cargo-link" data-bs-toggle="tab" role="tab"
                  tabindex="-1">Inbound Cargo</a>
                }
                @if (appContext.isTransitViewer()) {
                  <a [routerLink]="['/transit']"
                    [ngClass]="{'active': appContext.getUrlPath() === '/transit'}"
                    class="nav-item nav-link d-none d-sm-block"
                  id="transit-link" data-bs-toggle="tab" role="tab" tabindex="-1">Transit</a>
                }
                @if (appContext.isTranshipmentDeclarant() || appContext.isAdmin()) {
                  <a [routerLink]="['/transhipment']"
                    [ngClass]="{'active': appContext.getUrlPath() === '/transhipment'}"
                    class="nav-item nav-link d-none d-sm-block"
                  id="transhipment-link" data-bs-toggle="tab" role="tab" tabindex="-1">Transhipment</a>
                }
                @if (appContext.isCommercialReleaseDeclarant()
                || appContext.isCommercialReleaseEditor() || appContext.isCommercialReleaseViewer()) {
                  <a [routerLink]="[commercialReleaseNewScreenPath]"
                     [ngClass]="{'active': appContext.getUrlPath() === '/commercial-release' || appContext.getUrlPath() === '/commercial-release-new'}"
                     class="nav-item nav-link d-none d-sm-block"
                     id="commercial-release-link" data-bs-toggle="tab" role="tab" tabindex="-1">Releases</a>
                }
                @if (appContext.isAdmin()) {
                  <a [routerLink]="['/message-overview']"
                    [ngClass]="{'active': appContext.getUrlPath() === '/message-overview'}"
                    class="nav-item nav-link d-none d-sm-block" id="message-overview-link" data-bs-toggle="tab"
                  role="tab" tabindex="-1">Outgoing</a>
                }
                @if (appContext.isWasteCollector() || appContext.isAdmin()) {
                  <a [routerLink]="['/waste']"
                    [ngClass]="{'active': appContext.getUrlPath() === '/waste'}"
                    class="nav-item nav-link d-none d-sm-block" id="waste-collector-link" data-bs-toggle="tab" role="tab"
                  tabindex="-1">Waste collections</a>
                }
                @if (appContext.isBunkerOperator() || appContext.isAdmin()) {
                  <a [routerLink]="['/bunkering']"
                    [ngClass]="{'active': appContext.getUrlPath() === '/bunkering'}"
                    class="nav-item nav-link d-none d-sm-block" id="bunkering-link" data-bs-toggle="tab" role="tab"
                  tabindex="-1">Bunkering</a>
                }
                @if (appContext.isAdmin()) {
                  <a [routerLink]="['/refdata']"
                    [ngClass]="{'active': appContext.getUrlPath() === '/refdata'}"
                    class="nav-item nav-link d-none d-sm-block" id="ref_data-link" data-bs-toggle="tab" role="tab"
                  tabindex="-1">Reference data</a>
                }
                <span class="ms-auto"></span>
                <div class="nav-item nav-link d-none d-sm-block has-news beamer-button" style="cursor: pointer;">
                  News
                </div>
                <a [href]="appContext.supportPageForTask" [title]="appContext.supportPageTooltip"
                  target="_blank" class="nav-item nav-link d-none d-sm-block" id="faq-link" role="tab"
                tabindex="-1">Support</a>
                <span class="d-none d-sm-block">
                  <app-feedback></app-feedback>
                </span>
              </div>
            </nav>
          </div>
          <!-- body -->
          @if (appContext.isNewRoute) {
            <main role="main" class="main d-flex align-self-stretch flex-grow-1" style="min-height: 0">
              <router-outlet></router-outlet>
            </main>
          } @else {
            <div class="page-section px-3">
              <router-outlet></router-outlet>
            </div>
          }
        </div>
      }
    </div>
  }
  @if (!env.maintenance) {
    <div id="logOutModal" class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Log out as Service Desk</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            </button>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to log out?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary" (click)="logOutAsServiceDesk()" data-bs-dismiss="modal">Log
              out as Service Desk
            </button>
          </div>
        </div>
      </div>
    </div>
    @if (!isEmergencyProcedureDisabled) {
      <div id=emergencyProcedureSettings class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog">
        <app-emergency-procedure-settings></app-emergency-procedure-settings>
      </div>
    }
  }
  @if (!env.maintenance) {
    <app-news class="d-none"></app-news>
  }
  @if (env.maintenance) {
    <div class="maintenance-wrapper row">
      <router-outlet></router-outlet>
    </div>
  }
}

<ng-template #portvisit>
  @if (!env.maintenance) {
    <div id='screen' [ngClass]="{'container-fluid px-0': !appContext.isNewRoute, 'new-look-and-feel': appContext.useNewLookAndFeel() }">
      <!--spinning wheel-->
      <div [hidden]="appContext.pendingProcesses.length === 0" class="position-fixed row h-100 w-100 m-0"
        style="z-index: 15000;">
        <div class="position-absolute bg-secondary h-100 w-100" style="opacity: 0.3"></div>
        @if (appContext.isNewRoute) {
          <img class=" mx-auto text-secondary align-self-center" src="assets/img/loading-icon.svg"
            style="width: 6rem; height: 6rem;"/>
        } @else {
          <div class="spinner-border mx-auto text-secondary align-self-center" role="status"
          style="width: 5rem; height: 5rem; border-width: 1rem;"></div>
        }
      </div>
      @if (appContext.userProfile) {
<div [ngClass]="{'admin' : appContext.isAdmin(), 'd-flex flex-column': appContext.isNewRoute,
    'min-vh-100': appContext.isNewRoute && !appContext.routeData?.manualScrolling,
    'vh-100': appContext.isNewRoute && appContext.routeData?.manualScrolling}">
          <!-- Top navbar -->
          <div class="row bg-portbase-blue sticky-top mx-0" style="z-index: 1029;">
            <nav class="page-section col navbar navbar-dark">
              <div class="container-fluid">
                <div class="w-100 d-sm-none navigation-mobile d-flex justify-content-between px-3">
                  <!-- Portbase logo -->
                  <a class="navbar-brand d-flex align-items-center" [attr.href]="s000Url" tabindex="-1">
                    <img src="assets/pb-logo.svg" class="d-inline-block align-top" alt="Portbase logo" width="128" height="32"/>
                    <span class="d-none d-sm-inline ms-3 ps-3 border-start">Port Visit</span>
                  </a>
                  <!-- mobile navbar buttons -->
                  <div class="d-flex justify-content-end">
                    <!-- top menu dropdown -->
                    <div class="btn-group">
                      <button class="btn btn-primary rounded bg-portbase-blue border-white" type="button" data-bs-toggle="dropdown">
                        <span class="fa-light fa-bars"></span>
                      </button>
                      <div class="dropdown-menu dropdown-menu-end mobile-menu">
                        @if (appContext.isAllowedToViewVisits()) {
                          <a [routerLink]="['/']" class="dropdown-item">Visits</a>
                        }
                        @if (appContext.isVisitDeclarant()) {
                          <a [routerLink]="['/newVisit']" class="dropdown-item">
                          New visit</a>
                        }
                        @if (appContext.isBunkerOperator() || appContext.isAdmin()) {
                          <a [routerLink]="['/bunkering']"
                          class="dropdown-item">Bunkering</a>
                        }
                        <a class="dropdown-item has-news beamer-button" data-bs-toggle="tab" role="tab" tabindex="-1">News</a>
                        @if (appContext.isServiceDesk()) {
                          <a href="#" class="dropdown-item" data-bs-toggle="modal" data-bs-target="#logOutModal" tabindex="-1">
                            Log out as Service Desk
                          </a>
                        }
                        @if (!isEmergencyProcedureDisabled &&
                            (appContext.isAdmin() || appContext.isServiceDesk())) {
                          <div class="dropdown-divider"></div>
                            <a class="dropdown-item"
                              data-bs-toggle="modal"
                              data-bs-target="#emergencyProcedureSettings">
                              Emergency procedure
                            </a>
                          <div class="dropdown-divider"></div>
                        }
                        <a class="dropdown-item" [attr.href]="s000Url">Go to home screen</a>
                        <a class="dropdown-item" [attr.href]="iamLogoutUrl">Leave Portbase PCS</a>
                        @if (!visitContext.isOrganisationOnlyCargoDeclarant()
                          && !appContext.isCustoms() && !visitContext.isAssignedFinancialDeclarant()) {
                          <div class="border-top border-dark col mt-2">
                            <app-confirmation-of-purchase></app-confirmation-of-purchase>
                            <app-notification-of-departure></app-notification-of-departure>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-none d-sm-flex justify-content-between w-100">
                  <!-- Portbase logo -->
                  <a class="navbar-brand d-flex align-items-center" [attr.href]="s000Url" tabindex="-1">
                    <img src="assets/pb-logo.svg" class="d-inline-block align-top" alt="Portbase logo" width="128" height="32"/>
                    <span class="d-none d-sm-inline ms-3 ps-3 border-start">Port Visit</span>
                  </a>
                  <!-- User profile dropdown (not displayed on mobile) -->
                  <div class="btn-group d-none d-sm-block">
                    <button class="btn text-white dropdown-toggle" type="button" data-bs-toggle="dropdown" tabindex="-1" id="user-button">
                      {{appContext.userProfile.organisation?.contact}}
                    </button>
                    <div class="dropdown-menu dropdown-menu-end">
                      <a [routerLink]="['/preferences']" class="dropdown-item" href="#">Preferences</a>
                      @if (appContext.isAdmin() || appContext.isCargoImportEditor()) {
                        <a [routerLink]="['/licensebook']"
                        class="dropdown-item">Warehouse licences</a>
                      }
                      @if (!cargoScreenEnabled) {
                        <a [routerLink]="['/addressbook']" class="dropdown-item">Address book</a>
                      }
                      @if (appContext.isTransitViewer()) {
                        <a [routerLink]="['/guarantees']" class="dropdown-item">
                        Transit guarantees</a>
                      }
                      @if (appContext.isTransitViewer()) {
                        <a [routerLink]="['/transitTemplates']" class="dropdown-item">
                        Transit templates</a>
                      }
                      @if (appContext.isTransitViewer()) {
                        <a [routerLink]="['/transitAddressBook']" class="dropdown-item">
                        Transit destinations</a>
                      }
                      @if (appContext.isCommercialReleaseDeclarant() || appContext.isCommercialReleaseEditor() ||
                        appContext.isCommercialReleaseViewer()) {
                        <a [routerLink]="['/releaseToParties']" class="dropdown-item">
                        Release-to parties</a>
                      }
                      <div class="dropdown-divider"></div>
                      @if (appContext.isAdmin()) {
                        <a [routerLink]="['/admin/panel']" class="dropdown-item">Admin panel</a>
                        <a [routerLink]="['/admin/organisationSettings']" class="dropdown-item">Organisation settings</a>
                        <a [routerLink]="['/admin/monitoring']" class="dropdown-item">Monitoring</a>
                        <a [routerLink]="['/commercial-release-dashboard']" class="dropdown-item">
                        Commercial release dashboard</a>
                        <a [routerLink]="['/encrypt']" class="dropdown-item">Encrypt</a>
                        <div class="dropdown-divider"></div>
                      }
                      @if (appContext.isServiceDesk()) {
                        <a href="#" class="dropdown-item" data-bs-toggle="modal" data-bs-target="#logOutModal">Log out as Service Desk</a>
                      }
                      @if (!isEmergencyProcedureDisabled &&
                          (appContext.isAdmin() || appContext.isServiceDesk())) {
                        <div class="dropdown-divider"></div>
                          <a class="dropdown-item"
                            data-bs-toggle="modal"
                            data-bs-target="#emergencyProcedureSettings">
                            Emergency procedure
                          </a>
                        <div class="dropdown-divider"></div>
                      }
                      <a class="dropdown-item" [attr.href]="s000Url">Go to home screen</a>
                      <a class="dropdown-item" [attr.href]="iamLogoutUrl">Leave Portbase PCS</a>
                      @if (appContext.environment === 'localhost') {
                        <div class="dropdown-divider"></div>
                      }
                      @if (appContext.environment === 'localhost') {
                        <div class="dropdown-item">
                          <app-user-menu></app-user-menu>
                        </div>
                      }
                      @if (appContext.isAdmin()) {
                        <div class="dropdown-item">
                          <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" role="switch" id="useNewLookAndFeelSwitch"
                                   [(ngModel)]="useOpenSearch" (ngModelChange)="changeUseOpenSearch($event)">
                            <label class="form-check-label pt-1" for="useNewLookAndFeelSwitch">Use OpenSearch</label>
                          </div>
                        </div>
                      }
                      @if (appContext.isAdmin()) {
                        <div class="dropdown-divider"></div>
                      }
                      @if (visit && !visitContext.isOrganisationOnlyCargoDeclarant() && !appContext.isCustoms() && !visitContext.isAssignedFinancialDeclarant()) {
                        <div class="border-top border-dark col mt-2 d-sm-none" style="min-width:20rem;">
                          <app-confirmation-of-purchase></app-confirmation-of-purchase>
                          <app-notification-of-departure></app-notification-of-departure>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </nav>
          </div>
          <!-- Sub-navbar mobile (XS screen size) -->
          @if (!appContext.isNewRoute) {
            <nav class="navbar navbar-light bg-white d-block d-sm-none sticky-top pb-2 ps-0 mx-0" style="top: 3.5rem; z-index: 1028;">
              <div class="container-fluid px-0">
                <a class="navbar-brand" href="#">
                  <app-vessel-details></app-vessel-details>
                </a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText"
                  aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                  <i class="fa fa-caret-down" aria-hidden="true"></i>
                </button>
                <div class="collapse navbar-collapse" id="navbarText">
                  <app-visit-status [mobile]="true"></app-visit-status>
                </div>
              </div>
            </nav>
          }
          <!-- Sub-navbar desktop -->
          <div class="row bg-portbase-blue sticky-top mx-0" style="top: 3.5rem; z-index: 1028;">
            <nav class="page-section col vesselcall-nav">
              <div class="nav nav-tabs navbar-dark border-bottom-0" role="tablist">
                <!-- Everything from this point is not rendered on small screens -->
                @if (appContext.isAllowedToViewVisits()) {
                  <a [routerLink]="['/']"
                    [ngClass]="{'active': appContext.getUrlPath() === '/'}" id="visit_overview-link" data-bs-toggle="tab"
                  role="tab" class="nav-item nav-link d-none d-sm-block" tabindex="-1">Visits</a>
                }
                @if (!isEmergencyProcedureDisabled && appContext.hasEmergencyProcedureAccess()) {
                  <a [routerLink]="['/emergency']"
                     [ngClass]="{'active': appContext.getUrlPath() === '/emergency'}"
                     class="nav-item nav-link d-none d-sm-block" id="emergency-procedure-link" data-bs-toggle="tab"
                     role="tab" tabindex="-1">Emergency</a>
                }
                @if (appContext.isVisitDeclarant() && !appContext.useNewLookAndFeel()) {
                  <a [routerLink]="['/newVisit']"
                    [ngClass]="{'active': appContext.getUrlPath() === '/newVisit'}"
                    class="nav-item nav-link d-none d-sm-block" id="new_visit-link" data-bs-toggle="tab" role="tab"
                  tabindex="-1">New visit</a>
                }
                @if (cargoScreenEnabled) {
                  <a [routerLink]="['/cargo']"
                    [ngClass]="{'active': appContext.getUrlPath() === '/cargo' || appContext.getUrlPath() === '/container'}"
                    class="nav-item nav-link d-none d-sm-block" id="cargo-link" data-bs-toggle="tab" role="tab"
                  tabindex="-1">Inbound Cargo</a>
                }
                @if (appContext.isTransitViewer()) {
                  <a [routerLink]="['/transit']"
                    [ngClass]="{'active': appContext.getUrlPath() === '/transit'}"
                    class="nav-item nav-link d-none d-sm-block"
                  id="transit-link" data-bs-toggle="tab" role="tab" tabindex="-1">Transit</a>
                }
                @if (appContext.isTranshipmentDeclarant() || appContext.isAdmin()) {
                  <a [routerLink]="['/transhipment']"
                    [ngClass]="{'active': appContext.getUrlPath() === '/transhipment'}"
                    class="nav-item nav-link d-none d-sm-block"
                  id="transhipment-link" data-bs-toggle="tab" role="tab" tabindex="-1">Transhipment</a>
                }
                @if (appContext.isCommercialReleaseDeclarant()
                || appContext.isCommercialReleaseEditor() || appContext.isCommercialReleaseViewer()) {
                  <a [routerLink]="[commercialReleaseNewScreenPath]"
                     [ngClass]="{'active': appContext.getUrlPath() === '/commercial-release' || appContext.getUrlPath() === '/commercial-release-new'}"
                     class="nav-item nav-link d-none d-sm-block"
                     id="commercial-release-link" data-bs-toggle="tab" role="tab" tabindex="-1">Releases</a>
                }
                @if (appContext.isAdmin()) {
                  <a [routerLink]="['/message-overview']"
                    [ngClass]="{'active': appContext.getUrlPath() === '/message-overview'}"
                    class="nav-item nav-link d-none d-sm-block" id="message-overview-link" data-bs-toggle="tab"
                  role="tab" tabindex="-1">Outgoing</a>
                }
                @if (appContext.isWasteCollector() || appContext.isAdmin()) {
                  <a [routerLink]="['/waste']"
                    [ngClass]="{'active': appContext.getUrlPath() === '/waste'}"
                    class="nav-item nav-link d-none d-sm-block" id="waste-collector-link" data-bs-toggle="tab" role="tab"
                  tabindex="-1">Waste collections</a>
                }
                @if (appContext.isBunkerOperator() || appContext.isAdmin()) {
                  <a [routerLink]="['/bunkering']"
                    [ngClass]="{'active': appContext.getUrlPath() === '/bunkering'}"
                    class="nav-item nav-link d-none d-sm-block" id="bunkering-link" data-bs-toggle="tab" role="tab"
                  tabindex="-1">Bunkering</a>
                }
                @if (appContext.isAdmin()) {
                  <a [routerLink]="['/refdata']"
                    [ngClass]="{'active': appContext.getUrlPath() === '/refdata'}"
                    class="nav-item nav-link d-none d-sm-block" id="ref_data-link" data-bs-toggle="tab" role="tab"
                  tabindex="-1">Reference data</a>
                }
                <span class="ms-auto"></span>
                <div class="nav-item nav-link d-none d-sm-block has-news beamer-button" style="cursor: pointer;">
                  News
                </div>
                <a [href]="appContext.supportPageForTask" [title]="appContext.supportPageTooltip"
                  target="_blank" class="nav-item nav-link d-none d-sm-block" id="faq-link" role="tab"
                tabindex="-1">Support</a>
                <span class="d-none d-sm-block">
                  <app-feedback></app-feedback>
                </span>
              </div>
            </nav>
          </div>
          <!-- body -->
          @if (appContext.isNewRoute) {
            <main role="main" class="main d-flex align-self-stretch flex-grow-1" style="min-height: 0">
              <router-outlet></router-outlet>
            </main>
          } @else {
            <div class="page-section px-3">
              <router-outlet></router-outlet>
            </div>
          }
        </div>
      }
    </div>
  }

  @if (!env.maintenance) {
    <div id="logOutModal" class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Log out as Service Desk</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            </button>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to log out?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary" (click)="logOutAsServiceDesk()" data-bs-dismiss="modal">Log
              out as Service Desk
            </button>
          </div>
        </div>
      </div>
    </div>
  }

  @if (!env.maintenance) {
    <app-news class="d-none"></app-news>
  }
  @if (env.maintenance) {
    <div class="maintenance-wrapper row">
      <router-outlet></router-outlet>
    </div>
  }
</ng-template>

<ng-template #timoutModal>
  <div class="modal-content">
    <div class="modal-header border-0">
      <h5 class="modal-title">Are you still there?</h5>
    </div>
    <div class="modal-body border-0 p-3">
      <p>You haven't been active on this screen for a while now. To protect your information, you will be logged out
      in {{ (timeoutCount | async) }}.</p>
    </div>
    <div class="modal-footer border-0">
      <button type="button" class="btn btn-outline-secondary" (click)="logOut()">Log out</button>
      <button type="button" class="btn btn-primary" (click)="continueSession()">Continue session</button>
    </div>
  </div>
</ng-template>

<app-confirmation-modal></app-confirmation-modal>
<app-edit-modal
[ngClass]="appContext.isNewRoute && appContext.routeData?.manualScrolling ? 'disable-padding' : ''"></app-edit-modal>
<app-ndjson-status></app-ndjson-status>

<ng-template #oldSpinner>
  <div class="spinner-border mx-auto text-secondary align-self-center" role="status"
  style="width: 5rem; height: 5rem; border-width: 1rem;"></div>
</ng-template>

<ng-template #normalApplication>
  <div class="page-section px-3">
    <router-outlet></router-outlet>
  </div>
</ng-template>
